import React, { useEffect, useState } from "react";
import AddNewEntry from "./AddNewEntry";
import { getSalesReportHeaderDetails } from "../../services/salesReportService";
import { getDistributorNames } from "../../Common/functions";

const baseTitles = [
  { title: "Today" },
  { title: "This week" },
  { title: "This month" },
  { title: "Total" },
];

const Header = ({ stats, userRole }) => {
  const [openAddNewBox, setOpenAddNewBox] = useState(false);
  const [values, setValues] = useState(["0", "0", "0", "0"]);

  const getHeadersDetails = async () => {
    try {
      const payload = {
        category: "customer visit",
        distributor_name: getDistributorNames(),
      };
      const response = await getSalesReportHeaderDetails(payload);
      const totalRecords = response?.data?.total_records;

      if (totalRecords) {
        setValues([
          totalRecords.Today || 0,
          totalRecords.ThisWeek || 0,
          totalRecords.ThisMonth || 0,
          totalRecords.EntireTime || 0,
        ]);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching header details:", error);
    }
  };

  useEffect(() => {
    getHeadersDetails();
  }, []);

  return (
    <>
      <div className="px-0 sm:px-4 space-y-6 pt-4">
        <div className="flex justify-between gap-2">
          <h1 className="text-2xl leading-9 font-bold sm:text-3xl text-text1">
            Customer Visit
          </h1>
          <div>
            <button
              className="text-white text-sm bg-primary px-3 py-2 rounded-md"
              onClick={() => setOpenAddNewBox(true)}
            >
              Add customer
            </button>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-3">
          {baseTitles.map((item, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-3 lg:p-6 flex justify-between items-center w-full shadow-lg"
            >
              <div>
                <h2 className="text-sm font-medium text-text2 text-left">
                  {item.title}
                </h2>
                <p className="text-3xl font-bold text-text2 text-left">
                  {values[index]}
                </p>
              </div>
            </div>
          ))}
        </div>
        <hr />
      </div>
      {/* AnimatePresence ensures exit animations work */}

      {openAddNewBox && (
        <AddNewEntry
          userRole={userRole}
          closeModal={() => setOpenAddNewBox(false)}
        />
      )}
    </>
  );
};

export default Header;
